export { IncludedCompartmentPathways } from './IncludedCompartmentPathways.component';
